import en from '@/locales/en'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getTrans = (_locale?: string) => en

const useTrans = () => en

export default useTrans
